import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { BREEDS } from '../data/mock';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const StudCard = ({ stud, onEdit, isAdmin }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const breed = BREEDS.find(b => b.id === stud.breed);
  
  const images = stud.images && stud.images.length > 0 
    ? stud.images 
    : ['https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400'];

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <Card className="group overflow-hidden bg-white border-purple-100 hover:shadow-xl transition-all duration-500 hover:-translate-y-1">
      <div className="relative overflow-hidden">
        <img
          src={images[currentImageIndex]}
          alt={breed?.name || 'Reproductor'}
          className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-105"
        />
        
        {/* Image navigation */}
        {images.length > 1 && (
          <>
            <button
              onClick={prevImage}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-1 rounded-full shadow-md transition-all"
            >
              <ChevronLeft className="w-5 h-5 text-purple-800" />
            </button>
            <button
              onClick={nextImage}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-1 rounded-full shadow-md transition-all"
            >
              <ChevronRight className="w-5 h-5 text-purple-800" />
            </button>
            
            {/* Image dots */}
            <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
              {images.map((imgUrl, idx) => (
                <span
                  key={`dot-${idx}-${imgUrl.slice(-12)}`}
                  className={`w-2 h-2 rounded-full transition-all ${
                    idx === currentImageIndex ? 'bg-purple-500' : 'bg-white/60'
                  }`}
                />
              ))}
            </div>
          </>
        )}
      </div>
      
      <CardContent className="p-4">
        {/* Solo Raza */}
        <h3 className="text-xl font-bold text-purple-900 text-center">
          {breed?.icon} {breed?.name}
        </h3>
        
        {/* Image count */}
        <p className="text-xs text-purple-400 text-center mt-2">
          📷 {images.length} foto{images.length !== 1 ? 's' : ''}
        </p>
        
        {isAdmin && (
          <button
            onClick={() => onEdit(stud)}
            className="w-full mt-3 py-2 bg-purple-100 text-purple-800 rounded-lg font-semibold hover:bg-purple-200 transition-all duration-300"
          >
            Editar
          </button>
        )}
      </CardContent>
    </Card>
  );
};
